module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/symbolsJ109@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/symbolsJ109@1x.png
// module id = 722
// module chunks = 0